export default "__VITE_ASSET__ff0ae3e5__"